module.exports = __webpack_public_path__ + "img/09b-osm-outros-dept-assuntos.7eb28a5e.png";